import { Injectable } from '@angular/core'
import { AbstractCoreEnvService } from '../abstract_class/abstract-core-env-service'
import { CoreSettingsService } from '../settings/core-settings.service'

@Injectable({
  providedIn: 'root'
})
export class CoreEnvironmentService extends AbstractCoreEnvService {
  constructor(protected coreSettings: CoreSettingsService) {
    super()
  }

  getBaseURL(): string {
    return this.coreSettings.settings.baseUrl
  }

  getBeatmakerApiBaseUrl(): string {
    return this.coreSettings.settings.beatmakerApiBaseUrl
  }

  getArtistAdministrationLink(): string {
    return this.coreSettings.settings.artistAdministrationLink
  }

  getBmstvURL(): string {
    return this.coreSettings.settings.bmstvUrl
  }
}
